import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/storage";
import * as jsPDF from 'jspdf';
import { EISAI_LOGO } from '../images';
import { DatabaseProvider } from '../database/database';
import moment from 'moment';
import { PatientProvider } from '../patient/patient';

@Injectable()
export class PdfAdverseEventProvider {

  pdf: any;
  pageHeight: number;
  pageWidth: number;
  pageNumber: number = 0;
  startx: number = 40;
  starty: number = 40;
  x: number = 40;
  y: number = 40;
  supplies: any[];

  clinic: any;

  task: AngularFireUploadTask;
  filepath: any;

  constructor(private afStorage: AngularFireStorage, private database: DatabaseProvider, private db: PatientProvider) {
  }

  public createAdverseEventForm(program_id, program_name, ae) {
    console.log('Creating ae: ', ae);
    this.pdf = new jsPDF('p', 'pt', 'letter');
    this.pageHeight = this.pdf.internal.pageSize.height;
    this.pageWidth = this.pdf.internal.pageSize.width;
    this.pdf.deletePage(1);

    return new Promise((resolve, reject) => {
      const start = async () => {
        await this.addAE(program_name, ae);
        console.log('done pdf');
        this.pdf.save('test.pdf');
        resolve('test');
        // const file = this.pdf.output("blob")
        // const filepath = await this.uploadOrdertoFirebase(program_id, program_name, patient, file, 'Order', order.order_number, user);
        // console.log('Finished Everything, here is the file: ', filepath);
        // resolve(filepath);
      }
      start();
    });
  }

  private async addAE(program_name, ae)  {
    return new Promise(async (resolve, reject) => {
      
      await this.addNewPage('','');

      // Header
      this.y += 20;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 20;
      this.pdf.setFontSize(18);
      this.pdf.setFontType("bold");
      this.pdf.text('Adverse Event - ' + ae.ae_number, this.pageWidth / 2, this.y, 'center'); this.y += 5;
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;
      this.pdf.setFontSize(12);
      this.pdf.setFontType("normal");

      // Date
      this.pdf.text('Date: ' + moment(ae.createdAt.toDate()).format('MMM-DD-YYYY'), this.x, this.y); this.y += 15;

      // // NCM
      // this.pdf.text('Case Worker: ' + patient.ncm.display_name, this.x, this.y); this.y += 15;

      // // NCM
      // this.pdf.text('Order Number: ' + order.order_number, this.x, this.y); this.y += 15;
      // this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;

      // this.pdf.setFontType("bold");
      // this.pdf.text('Patient', this.x, this.y);
      // this.pdf.text('Physician', this.x + 200, this.y);
      // if (order.pharmacy) this.pdf.text('Pharmacy', this.x + 400, this.y); 
      // this.y += 15;

      // this.pdf.setFontType("normal");
      // this.pdf.text(patient.first_name + ' ' + patient.last_name, this.x, this.y);
      // this.pdf.text('Dr. ' + order.doctor.first_name + ' ' + order.doctor.last_name, this.x + 200, this.y);
      // if (order.pharmacy) this.pdf.text(order.pharmacy.name, this.x + 400, this.y); 
      // this.y += 15;

      // this.pdf.text(patient.address, this.x, this.y);
      // if (order.doctor.address) this.pdf.text(order.doctor.address, this.x + 200, this.y);
      // if (order.pharmacy) this.pdf.text(order.pharmacy.address, this.x + 400, this.y); this.y += 15;

      // this.pdf.text(patient.city + ', ' + patient.province, this.x, this.y);
      // if (order.doctor.address) this.pdf.text(order.doctor.city + ', ' + order.doctor.province, this.x + 200, this.y);
      // if (order.pharmacy) this.pdf.text(order.pharmacy.city + ', ' + order.pharmacy.province, this.x + 400, this.y); this.y += 15;

      // this.pdf.text(patient.postal_code, this.x, this.y);
      // if (order.doctor.address) this.pdf.text(order.doctor.postal_code, this.x + 200, this.y);
      // if (order.pharmacy) this.pdf.text(order.pharmacy.postal_code, this.x + 400, this.y); this.y += 15;

      // if (patient.dob) this.pdf.text('DOB: ' + moment(patient.dob.seconds * 1000).format('MMM-DD-YYYY'), this.x, this.y);
      // if (order.doctor.fax_number) this.pdf.text('FAX: ' + order.doctor.fax_number, this.x + 200, this.y);
      // if (order.pharmacy) this.pdf.text('FAX: ' + order.pharmacy.fax_number, this.x + 400, this.y); 
      // this.y += 15;
      
      // this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;

      // // Therapy and Indication
      // if (order.type === 'Drug') {
      //   if (patient.therapy) this.pdf.text('Therapy: ' + patient.therapy + ' - ' + order.commercial_compassionate, this.x, this.y); this.y += 15;
      //   if (patient.indication) this.pdf.text('Indication: ' + patient.indication, this.x, this.y); this.y += 15;
      //   this.pdf.text('Dose: ' + order.dose, this.x, this.y); this.y += 15;
      //   this.pdf.text('Repeats: ' + order.repeats, this.x, this.y); this.y += 15;
      //   this.pdf.text('Quantity: ' + order.quantity, this.x, this.y); this.y += 15;
      // } else {
      //   this.pdf.text(order.type, this.x, this.y); this.y += 15;
      //   if (patient.therapy) this.pdf.text('Therapy: ' + patient.therapy, this.x, this.y); this.y += 15;
      //   if (patient.indication) this.pdf.text('Indication: ' + patient.indication, this.x, this.y); this.y += 15;
      // }

      // this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 25;
      // this.pdf.setFontType("bold");
      // this.pdf.text('Instructions', this.x, this.y); this.y += 15;

      // this.pdf.setFontType("normal");
      // if (order.notes)  {
      //   let notes = this.pdf.splitTextToSize(order.notes, this.pageWidth - 100);
      //   this.pdf.text(this.x, this.y, notes); this.y += 25;
      // }
      resolve('Finished Order Contents');
    });
  }

  private async addNewPage(header_text, footer_text) {
    return new Promise(async (resolve, reject) => {
      this.pdf.addPage();
      this.pageNumber += 1;
      this.y = this.starty;
      await this.addHeader(header_text);
      await this.addFooter(footer_text);
      resolve('New Page Added');
    });
  }

  private async addHeader(header_text) {
    return new Promise((resolve, reject) => {
      this.y = 40; 
      this.x = 40;

      // Add Eisai Logo
      this.pdf.addImage(EISAI_LOGO, 'png', this.x, this.y, 130, 65); this.y += 20;

      // Eisai Top Right Info
      this.pdf.setFont("helvetica"); 
      this.pdf.setFontType("bold");
      this.pdf.setFontSize(14);
      this.pdf.text('PHONE:', this.x + 350, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('1-844-980-0410', this.x  + 415, this.y); this.y += 20;

      this.pdf.setFontType("bold");
      this.pdf.text('FAX:', this.x + 350, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('1-844-980-0416', this.x + 415, this.y); this.y += 20;

      this.pdf.setFontType("bold");
      this.pdf.text('EMAIL:', this.x + 350, this.y); 
      this.pdf.setFontType("normal"); 
      this.pdf.text('info@eisaicares.ca', this.x + 415, this.y); this.y += 20;
      this.pdf.setFontType("normal"); 
      resolve();
    });
  }

  private addFooter(footer_text)  {
    return new Promise((resolve, reject) => {
      // Footer with Clinic and Page Number
      this.pdf.setFontSize(12);
      this.pdf.line(this.x, this.pageHeight - 40, this.pageWidth - 40, this.pageHeight - 40);
      let nextline = footer_text;
      // if(batch.order_batch) { nextline += ' - ' + batch.order_batch; }
      this.pdf.text(nextline, this.x, this.pageHeight - 25);
      // this.pdf.text(this.pageNumber.toString(), this.pageWidth - 60, this.pageHeight - 25);
      resolve('Footer Complete');
    });
  }

  private async uploadLettertoFirebase(program_id, program_name, patient, file: any, doc_type, user) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      const dt = new Date().getTime();
      const filename = `${dt}_Letter_${patient.program_patient_id}_${patient.last_name}.pdf`;
      filePath = 'documents/' + filename;
  
      console.log("File Path: ", filePath);
      this.task = this.afStorage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          console.log("File Upload Complete: ", file); 
          file['ext'] = 'pdf';
          file['url'] = u;
          file['doc_type'] = doc_type;
          file['mimetype'] = 'application/pdf';
          file['filename'] = filename;
          const patientnew = {
            id: patient.id,
            first_name: patient.first_name,
            last_name: patient.last_name,
            program_patient_id: patient.program_patient_id
          }
          this.db.addDocument(program_id, patientnew, file, user)
          resolve(u);
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }

  private async uploadOrdertoFirebase(program_id, program_name, patient, file: any, doc_type, order_id, user) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      const dt = new Date().getTime();
      const filename = `${dt}_${order_id}_${patient.program_patient_id}_${patient.last_name}.pdf`;
      filePath = 'orders/' + filename;
  
      console.log("File Path: ", filePath);
      this.task = this.afStorage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          console.log("Order Upload Complete: ", file); 
          resolve(u);
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/pdf/pdfAdverseEvent.ts